import { execute, gql, type VariablesOf } from './financial-bff-gql'

export const RISK_FINANCING_REGISTER_CREDENTIAL = gql(`
  mutation RiskFinancingRegisterCredential($input: RegisterRevalidationCredentialInput!) {
    risk_financing_register_credential(input: $input) {
      success
      message
    }
  }
`)

export type RiskFinancingRegisterCredentialVariables = VariablesOf<typeof RISK_FINANCING_REGISTER_CREDENTIAL>

export async function mutateRiskFinancingRegisterCredential(
  variables: RiskFinancingRegisterCredentialVariables,
) {
  const data = await execute(RISK_FINANCING_REGISTER_CREDENTIAL, variables)
  return data.risk_financing_register_credential
}
